"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="e5e09d6f-80b3-5a12-889b-88d066d35f1a")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.FileStatus = void 0;
var FileStatus;
(function (FileStatus) {
    FileStatus["PENDING"] = "Pending";
    FileStatus["PROCESSING"] = "Processing";
    FileStatus["PROCESSED"] = "Processed";
    FileStatus["ERROR"] = "Error";
})(FileStatus || (exports.FileStatus = FileStatus = {}));
//# sourceMappingURL=file.js.map
//# debugId=e5e09d6f-80b3-5a12-889b-88d066d35f1a
